
import { VionOrder } from '@tcc-mono/vandijk/shared/data-access/models';
import { Injectable } from '@angular/core';
import { CoreRepository } from '@tcc-mono/shared/data-access';
import { VionOrderService } from '@tcc-mono/vandijk/shared/data-access/vandijk-api';


@Injectable({
  providedIn: 'root'
})
export class VionOrderRepository extends CoreRepository<VionOrder> {

  public constructor(
    protected readonly _vionOrderService: VionOrderService
  ) {
    super(
      { name: 'vionOrders' },
      _vionOrderService
    )
  }
}
